import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FallbackImage from '../Image/FallbackImage';

export const PDPImage = ({
  src,
  alt = 'no image available',
  height,
  width,
  size,
}) => {
  const [image, setImage] = useState({ src, error: false });

  useEffect(() => {
    setImage({ src, error: false });
  }, [src]);

  const renderSizes = () => {
    if (!size) return null;
    return (
      <>
        {size.LG ? <source media="(min-width:980px)" srcSet={size.LG} /> : null}
        {size.MD ? <source media="(min-width:740px)" srcSet={size.MD} /> : null}
        {size.SM ? <source media="(min-width:320px)" srcSet={size.SM} /> : null}
      </>
    );
  };

  if (!image.src || image.error) {
    return (
      <picture>
        <FallbackImage />
      </picture>
    );
  }
  return (
    <picture>
      {renderSizes()}
      <img
        src={image.src}
        alt={alt}
        height={height}
        width={width}
        onError={() => setImage({ ...image, error: true })}
      />
    </picture>
  );
};

PDPImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  size: PropTypes.object,
};

export default PDPImage;
